import classNames from "classnames";
import type { CSSProperties } from "react";

import type { V2LabelDef } from "../../../types";
import styles from "./ItemLabel.module.scss";

interface ItemLabelProps {
  label: V2LabelDef;
}

/**
 * Renders the label portion of an item.
 * Orientation (top / left / right / bottom / none) is handled by the parent
 * Item component — ItemLabel just renders the styled text node.
 */
export function ItemLabel({ label }: ItemLabelProps) {
  const {
    text,
    textAlign,
    color,
    backColor,
    outline,
    padding,
    bold,
    italic,
    underline,
    width,
    fontSize,
    align,
    style: labelStyle,
  } = label;
  const inlineStyle: CSSProperties = {
    ...(textAlign && {
      justifyContent:
        textAlign === "left"
          ? "flex-start"
          : textAlign === "right"
            ? "flex-end"
            : textAlign === "center"
              ? "center"
              : "flex-start",
    }),
    ...(color && { color }),
    ...(backColor && { backgroundColor: backColor }),
    ...(outline && { border: outline }),
    ...(padding !== undefined && { padding }),
    ...(width && { width, flexShrink: 0 }),
    ...(fontSize && { fontSize }),
    ...(align && { alignSelf: align }),
    height: "100%",
  };

  const labelClassName = classNames(
    styles.label,
    labelStyle === "solid" && styles.solid,
    labelStyle === "subtle" && styles.subtle,
    bold && styles.bold,
    italic && styles.italic,
    underline && styles.underline,
  );

  return (
    <span className={labelClassName} style={inlineStyle}>
      {text}
    </span>
  );
}
